// src/api/endpoints.js
// Centralized API endpoint constants — derived from API endpoint inventory
const BASE = import.meta.env.VITE_API_BASE_URL;

export const AUTH_API = `${BASE}/auth`;
export const RESTAURANT_API = `${BASE}/restaurants`;
export const CATEGORY_API = `${BASE}/menu/categories`;
export const MENU_ITEM_API = `${BASE}/menu/items`;
export const COMPONENT_API = `${BASE}/menu/components`;
export const OPTIONS_API = `${BASE}/menu/components/options`;
export const OFFER_TYPES_API = `${BASE}/menu/offer-types`;
export const ORDER_API = `${BASE}/orders`;
export const MENU_ORDER_API = `${BASE}/menu/orders`;
export const TABLES_API = `${BASE}/tables`;
export const SERVICE_API = `${BASE}/service-requests`;
export const VENUE_API = `${BASE}/venues`;
export const USERS_API = `${BASE}/users`;
export const RESTAURANT_TYPE_API = `${BASE}/restaurant-types`;
export const DASHBOARD_API = `${BASE}/dashboard`;
export const RATINGS_API = `${BASE}/ratings`;
export const PAYMENT_INITIATE_API = `${BASE}/payment/initiate`;
export const PAYMENT_STATUS_API = `${BASE}/payment/status`;
export const RESERVATION_API = `${BASE}/reservations`;
export const ROOM_API = `${BASE}/rooms`;
export const OPENING_HOURS_API = `${BASE}/opening-hours`;
export const QR_CODE_API = `${BASE}/qr-codes`;
export const PAYMENT_API = `${BASE}/payment`;
export const TABLE_MANAGEMENT_API = `${BASE}/table-management`;
export const CUSTOMER_API = `${BASE}/customers`;
export const CUSTOMER_FAVORITES_API = `${CUSTOMER_API}/favorites`;
export const CUSTOMER_LOYALTY_API = `${CUSTOMER_API}/loyalty`;
export const TAX_RULES_API = (restaurantId) =>
  `${RESTAURANT_API}/${restaurantId}/tax-rules`;
